<template>
  <div class="management-agent-box">
    <div class="content-box">
      <!-- 搜索栏 -->
      <div class="content_title data_screen">
        <div class="data_screen_line">
          <span class="title">用户管理</span>

          <span>
            <el-input
              v-model="search.content"
              placeholder="用户昵称，手机号"
              style="width: 300px"
              size="small"
              suffix-icon="el-icon-search"
              @change="pageChange(1)"
              clearable
            />
          </span>
          <span class="data_screen_tab">
            <!-- 分类  -->
            <el-select
              v-model="search.bindDevice"
              clearable
              placeholder="请选择"
              size="small"
              style="width: 150px"
              @change="pageChange(1)"
            >
              <el-option label="不限绑定" value />
              <el-option
                v-for="item in bindState"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </span>
          <el-button
            class="data_screen_tab"
            size="small"
            @click="pageChange(1)"
            >查询</el-button>
        </div>
      </div>
      <!-- 具体内容 -->
      <div class="content">
        <div class="content_auto">
          <!-- 表格 -->
          <el-table :data="table_data" style="width: 100%">
            <el-table-column prop="picture" label="头像" align="center">
              <template slot-scope="scope">
                <el-image
                  style="width: 80px; height: 80px"
                  :src="scope.row.picture"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="用户手机"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="nickName"
              label="用户昵称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="deviceAMac"
              label="绑定A设备"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{scope.row.deviceAMac?scope.row.deviceAMac:'未绑定'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="deviceBMac"
              label="绑定B设备"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{scope.row.deviceBMac?scope.row.deviceBMac:'未绑定'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="loginTime"
              label="最近登录时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="registerTime"
              label="注册时间"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="color: #00cb9f"
                  @click="clickInfo(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 表格结束 -->
          <!-- 分页 -->
          <div class="page">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="page.total"
              :page-size="page.size"
              @current-change="pageChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      // 搜索
      search: {
        content: null,
        login: "",
        bindDevice: "",
      },
      loginState: [
        { label: "有登录", value: 1 },
        { label: "未登录", value: 0 },
      ],
      bindState: [
        { label: "有绑定", value: 1 },
        { label: "未绑定", value: 0 },
      ],
      // 分页属性
      page: {
        currPage: 1,
        size: 10,
        total: 100,
      },
      // 表格数据
      table_data: [],
      // return 结束
    };
  },
  updated() {},
  created() {
    this.query();
  },
  methods: {
    // 分页改变
    pageChange(res) {
      this.page.currPage = res;
      this.query();
    },
    // 点击了详情
    clickInfo(row) {
      var data = {
        type: "userInfo",
        add: false,
        data: row,
      };
      sessionStorage.setItem("dataInfo", JSON.stringify(data));
      this.$router.push({ path: "/user/info" });
    },
    // 查询数据
    query() {
      let that = this;
      const url = "/api/web/user/pageUser";
      that.table_data = [];
      this.$axios
        .post(url, {
          page: this.page.currPage,
          size: this.page.size,
          param: {
            nickName: this.search.content,
            bindDevice: this.search.bindDevice
          },
        })
        .then((res) => {
          if (res.data.code == 1000) {
            that.table_data = res.data.data.list;
            that.page.total = Number(res.data.data.totalItems);
          } else if (res.data.code == 4030) {
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.info(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // methods 结束
  },
};
</script>

<style scoped>
/* 外盒子 */
.management-agent-box {
  height: 100%;
  width: 100%;
  padding: 15px;
  background: #f8fafb;
}
/* 内盒子 */
.content-box {
  width: 100%;
  height: 100%;
}
/* 内容盒子 */
.content_title {
  width: 100%;
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  border-radius: 5px;
}

/* 内容盒子 */
.content {
  width: 100%;
  height: calc(100% - 90px);
  /* height: 100%; */
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
}
.content_auto {
  height: 100%;
  overflow-y: auto;
}
/* 滚动条样式 */
.content_auto::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.content_auto::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #00cb9f;
}
.content_auto::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(167, 163, 163, 0.2);
  border-radius: 10px;
  background: #ededed;
}

/* 搜索栏 */
.data_screen {
  height: 90px;
  margin-bottom: 15px;
  padding-top: 0px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

/* 搜索栏居中 */
.data_screen_line {
  line-height: 32px;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: flex-start;
}

.data_screen .data_screen_tab {
  margin-left: 20px;
}
/* 标题 */
.title {
  margin-right: 30px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #454647;
  letter-spacing: 0;
}

/* 分页 */
.page {
  /* position:absolute;
  bottom: 50px;
  right: 50px; */
  float: right;
  margin-top: 20px;
}
/* 查询按钮 */
.search_btn{
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/user/user.vue